



























import Vue from 'vue'
import ProductMenuList from '@/common/components/globalHeader/ProductMenuList.vue'
import { ProductCategory } from '@/model/productCategory'
import { BrandModel } from '@/common/types/brands'

export default Vue.extend({
  components: {
    ProductMenuList
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    productMenuOpen: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    brands: {
      type: Array as () => BrandModel[],
      required: true
    }
  },
  data(): {
    isProductMenuOpen: boolean
  } {
    return {
      isProductMenuOpen: false
    }
  },
  watch: {
    isProductMenuOpen() {
      this.$emit('update:productMenuOpen', this.isProductMenuOpen)
    }
  }
})
